// extracted by mini-css-extract-plugin
module.exports = {"Container":"changelog_Container__3hthB","Title":"changelog_Title__Z1Mvp"};